import type { FormatXMLElementFn } from "intl-messageformat";
import type { ReactNode } from "react";

export default {
  strong: (text) => <strong className="text-slate-700 dark:text-white">{text}</strong>,
  b: (text) => <strong className="text-slate-700 dark:text-white">{text}</strong>,
  em: (text) => <em className="italic">{text}</em>,
  italic: (text) => <em className="italic">{text}</em>,
} satisfies Record<string, FormatXMLElementFn<ReactNode>>;
